var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pdfvuer"}},[(_vm.loaded && _vm.pdfdata)?_c('div',_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,staticClass:"d-block mb-4",staticStyle:{"width":"100%"},attrs:{"src":_vm.pdfdata,"page":i}})}),1):_c('div',{staticClass:"loading-content"},[_vm._v(" loading content, please wait ... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }